import { createContext, useContext, useState, ReactNode } from 'react';
import { UserInfoForm } from '../types';

interface SessionContextType {
  userInfo: UserInfoForm | undefined;
  setUserInfo: (userInfo: UserInfoForm) => void;
}

const SessionContext = createContext<SessionContextType>({
  userInfo: undefined,
  setUserInfo: () => {},
});

export const SessionProvider = ({ children }: { children: ReactNode }) => {
  const [userInfo, setUserInfo] = useState<UserInfoForm | undefined>(undefined);

  return (
    <SessionContext.Provider value={{ userInfo, setUserInfo }}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => useContext(SessionContext);